import React, { useMemo, useRef } from 'react';

import useI18n from 'hooks/use-i18n';

import DoneIcon from './assets/done.svg';
import useStyles from './styles';

import { GenerationStep as GenerationStepType } from '../../constants';
import CircularProgressOutlined from '../CircularProgressOutlined';

interface Props {
    value: GenerationStepType;
    variant?: 'active' | 'completed' | 'default';
    className?: string;
}

const GenerationStep: React.FC<Props> = ({ value, variant = 'default', className }) => {
    const i18n = useI18n();
    const { classes, cx } = useStyles();
    const containerRef = useRef<HTMLSpanElement | null>(null);

    const label = useMemo(() => {
        switch (value) {
            case GenerationStepType.ANALYZING:
                return i18n('Analyzing');
            case GenerationStepType.SEARCH:
                return i18n('Searching');
            case GenerationStepType.CORRELATING:
                return i18n('Correlating');
            case GenerationStepType.PREPARING:
                return i18n('Preparing');
            case GenerationStepType.FINALIZING:
                return i18n('Final insights');
            default:
                return value;
        }
    }, [i18n, value]);

    return (
        <span
            ref={containerRef}
            data-generation-step={value}
            className={cx(
                classes.root,
                {
                    [classes._completed]: variant === 'completed',
                    [classes._active]: variant === 'active'
                },
                className
            )}
        >
            {variant === 'active' ? (
                <CircularProgressOutlined size={16} thickness={6} />
            ) : variant === 'completed' ? (
                <DoneIcon />
            ) : (
                <CircularProgressOutlined size={16} thickness={6} value={0} variant="determinate" />
            )}
            {label}
        </span>
    );
};

export default GenerationStep;
